export const ADMIN_NAVIGATION_ACTION_TYPES = Object.freeze({
  PANEL: "panel",
  ROUTE: "route",
});

export const ADMIN_NAVIGATION_ACTION_TYPE_VALUES = Object.freeze(
  Object.values(ADMIN_NAVIGATION_ACTION_TYPES)
);

export const ADMIN_PANEL_REQUIRED_STRING_FIELDS = Object.freeze([
  "title",
  "description",
  "keyPrefix",
]);

export const ADMIN_PANEL_OPTIONAL_STRING_FIELDS = Object.freeze([
  "eyebrow",
]);

export const ADMIN_PANEL_OPTIONAL_BOOLEAN_FIELDS = Object.freeze([
  "clearSearchParamsOnClose",
]);

export const ADMIN_PANEL_OPTIONAL_OBJECT_FIELDS = Object.freeze([
  "props",
]);

export const ADMIN_NAVIGATION_REQUIRED_STRING_FIELDS = Object.freeze([
  "tab",
  "icon",
  "title",
  "description",
]);

function freezeObject(value) {
  if (
    value === null ||
    typeof value !== "object" ||
    Object.isFrozen(value)
  ) {
    return value;
  }

  Object.values(value).forEach((nestedValue) => {
    freezeObject(nestedValue);
  });

  return Object.freeze(value);
}

export function freezeAdminNavigationRegistry(entries = []) {
  return Object.freeze(
    entries.map((entry) =>
      freezeObject({
        ...entry,
        action: entry?.action
          ? { ...entry.action }
          : entry?.action,
      })
    )
  );
}

export function freezeAdminPanelRegistry(registry = {}) {
  const frozenEntries = Object.fromEntries(
    Object.entries(registry).map(([panelMode, config]) => [
      panelMode,
      freezeObject({
        ...config,
        props: config?.props
          ? { ...config.props }
          : config?.props,
      }),
    ])
  );

  return Object.freeze(frozenEntries);
}

export function freezeAdminKeyedConfigRegistry(registry = {}) {
  const frozenEntries = Object.fromEntries(
    Object.entries(registry).map(([key, config]) => [
      key,
      freezeObject({ ...config }),
    ])
  );

  return Object.freeze(frozenEntries);
}
